import { useChatTyping } from "../ChatTurnLayout/ChatTypingContext";
import styles from "./QuickReplies.module.scss";

export interface QuickReply {
  id: string;
  label: string;
  disabled?: boolean;
}

interface QuickRepliesProps {
  replies: readonly QuickReply[];
  onSelect: (id: string) => void;
  disabled?: boolean;
}

// Conversation actions: the answers the user can tap instead of typing.
export function QuickReplies({
  replies,
  onSelect,
  disabled = false,
}: QuickRepliesProps) {
  const typing = useChatTyping();

  // Offered once the bot has finished asking.
  if (typing && typing.queue.length > 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      {replies.map((reply) => (
        <button
          key={reply.id}
          type="button"
          className={styles.reply}
          disabled={disabled || reply.disabled}
          onClick={() => onSelect(reply.id)}
        >
          {reply.label}
        </button>
      ))}
    </div>
  );
}
